import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './ForgotPasswordPage.module.css';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1=email, 2=kod+nowe hasło
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);

  const handleSendCode = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setInfo(data.message);
      setStep(2);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) return setError('Hasło musi mieć minimum 8 znaków');
    setLoading(true); setError(null);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, newPassword }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      navigate('/logowanie', { state: { info: data.message } });
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h1>{step === 1 ? 'Zapomniane hasło' : 'Nowe hasło'}</h1>
        <p className={styles.sub}>
          {step === 1
            ? 'Podaj adres e-mail — wyślemy kod do resetowania hasła.'
            : `Kod wysłany na ${email}. Wpisz go poniżej i ustaw nowe hasło.`}
        </p>

        {error && <div className={styles.error}>{error}</div>}
        {info && step === 2 && <div className={styles.info}>{info}</div>}

        {step === 1 ? (
          <form onSubmit={handleSendCode} className={styles.form}>
            <div className={styles.field}>
              <label>E-mail</label>
              <input required type="email" placeholder="adres@email.pl" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <button type="submit" className={styles.submit} disabled={loading}>
              {loading ? 'Wysyłanie...' : 'Wyślij kod resetowania'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleReset} className={styles.form}>
            <div className={styles.field}>
              <label>Kod z e-maila (6 cyfr)</label>
              <input required type="text" inputMode="numeric" maxLength={6} placeholder="123456" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, ''))} />
            </div>
            <div className={styles.field}>
              <label>Nowe hasło (min. 8 znaków)</label>
              <input required type="password" placeholder="••••••••" minLength={8} value={newPassword} onChange={e => setNewPassword(e.target.value)} />
            </div>
            <button type="submit" className={styles.submit} disabled={loading}>
              {loading ? 'Zapisywanie...' : 'Ustaw nowe hasło'}
            </button>
            <button type="button" className={styles.back2} onClick={() => { setStep(1); setError(null); }}>
              ← Zmień e-mail
            </button>
          </form>
        )}

        <Link to="/logowanie" className={styles.back}>← Wróć do logowania</Link>
      </div>
    </div>
  );
}
